import { z } from 'zod';

export const TENANT_STATUSES = ['provisioning', 'active', 'failed', 'suspended'] as const;
export type TenantStatus = (typeof TENANT_STATUSES)[number];

export const MEMBERSHIP_ROLES = ['owner', 'admin', 'member'] as const;
export type MembershipRole = (typeof MEMBERSHIP_ROLES)[number];

export const CreateTenantSchema = z.object({
  /** Partita IVA: dalla partita IVA il sistema trova da solo la ragione sociale. */
  vat_number: z
    .string()
    .trim()
    .regex(/^[A-Z]{0,2}\d{8,13}$/i)
    .optional()
    .describe('Partita IVA dell’azienda: è l’unico dato da chiedere, la ragione sociale la trova il sistema'),
  /** Ragione sociale: non si chiede. Serve solo se la partita IVA non c'è o non si trova in nessun registro. */
  name: z.string().trim().min(2).max(160).optional().describe('Non chiederla all’utente: la trova il sistema dalla partita IVA'),
});
export type CreateTenantInput = z.infer<typeof CreateTenantSchema>;

/** Parola da scrivere per confermare l'eliminazione definitiva di un'azienda. */
export const DELETE_TENANT_WORD = 'ELIMINA';

/** Eliminazione definitiva: si conferma scrivendo la parola `DELETE_TENANT_WORD`. */
export const DeleteTenantSchema = z.object({
  confirm_word: z.string().trim().min(1),
});
export type DeleteTenantInput = z.infer<typeof DeleteTenantSchema>;

export const TenantSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  vat_number: z.string().nullable(),
  status: z.enum(TENANT_STATUSES),
  role: z.enum(MEMBERSHIP_ROLES),
  created_at: z.string(),
  provisioning_error: z.string().nullable(),
  /** Finché è in `provisioning`: com'è messo il job nella coda (ADR 0048), per la pagina «In preparazione». */
  provisioning_note: z.string().nullable().optional(),
});
export type Tenant = z.infer<typeof TenantSchema>;
